import script from "./AudienceFooterSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceFooterSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceFooterSkeleton.vue?vue&type=style&index=0&id=d75c9d9c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d75c9d9c"]])

export default __exports__